module.exports = __webpack_public_path__ + "media/images/knockoutbet__sample@2x-85e7ea46ad09189f2c2b60dd59209b45.png";